import { render, staticRenderFns } from "./InvestmentItem.vue?vue&type=template&id=f26f94e8"
import script from "./InvestmentItem.vue?vue&type=script&lang=js"
export * from "./InvestmentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports